import React from 'react';

import SignupHome from 'pages/authentication/sign-up-home';

export default function SignInPage() {
  return <SignupHome />;
}
